module.exports = __webpack_public_path__ + "static/blog-post-4-3f1110a38b496dd5bc431852253c860a.png";